/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Create_Tenant_PromptInputs */

const es_login_create_tenant_prompt = /** @type {(inputs: Login_Create_Tenant_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No tenés empresa en Nexata?`)
};

const en_login_create_tenant_prompt = /** @type {(inputs: Login_Create_Tenant_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have a Nexata organization?`)
};

/**
* | output |
* | --- |
* | "Don't have a Nexata organization?" |
*
* @param {Login_Create_Tenant_PromptInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const login_create_tenant_prompt = /** @type {((inputs?: Login_Create_Tenant_PromptInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Create_Tenant_PromptInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_login_create_tenant_prompt(inputs)
	return en_login_create_tenant_prompt(inputs)
});
export { login_create_tenant_prompt as "login.create_tenant_prompt" }